import React from 'react';

// tslint:disable max-line-length
const RIntroContentRemotePersonalTranscriptionMunch: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. So you’re the one getting the gift. Lucky. Someone you know has visited the museum. You were the lens for everything they looked at. They searched out things they thought you would care about and they took photos and made messages.</p>
  </>
);

export {
  RIntroContentRemotePersonalTranscriptionMunch,
};
